import { useState } from "react";
import { allWorks } from "@/utils/media";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/feature/SectionHeading";

const tabs = [
  { key: "latest", label: "最新更新", icon: "ri-time-line" },
  { key: "hot", label: "热门影视", icon: "ri-fire-line" },
];

const latest = [...allWorks].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 12);
const hot = [...allWorks].sort((a, b) => Number(b.hot) - Number(a.hot) || b.rating - a.rating).slice(0, 12);

export default function RecommendTabs() {
  const [tab, setTab] = useState("latest");
  const list = tab === "latest" ? latest : hot;

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-12">
      <SectionHeading
        icon="ri-movie-2-line"
        title="推荐影视内容"
        subtitle="精选最新更新与热门影视作品，点击卡片查看详情"
        moreTo="/category/movie"
        moreLabel="更多影片"
      />

      <div className="mb-5 inline-flex items-center gap-1 rounded-full border border-background-300/70 bg-background-50 p-1">
        {tabs.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setTab(item.key)}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              tab === item.key
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:bg-background-100"
            }`}
          >
            <i className={item.icon} />
            {item.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}